<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进华欣焱" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content" v-if="!about.content">
              公司成立于 2017 年，历经数载奋斗，不断发展壮大。公司
              运用自身在风力发电变桨行业及新能源充电电源行业十余年的
              知识底蕴及客户群体关系，重心打造一个全新的以注重新能源电
              能转换的高科技技术企业。
              产品主要涵盖：风力发电、车载电源、锂电充电、通信工控、
              军工定制、电机控制器等多个领域。
              公司现拥有多名长期从事风电行业及新能源充电电源行业
              的专业技术人才，研发底蕴深厚，技术实力强，可在整机生产、
              技术开发、技术配套、备件供应与维修、现场运维、机组检测技
              改等方面提供最具有价值的专业性技术服务
            </p>
            <p v-else v-html="about.content || ''"> 

            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course" v-if="courseList.length>0">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.content}}</p>
                        <p>{{courseOne.year}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <section class="content-culture" aria-labelledby="culture-title">
          <div class="culture-head">
            <span class="culture-kicker">CULTURE</span>
            <h3 id="culture-title">企业文化</h3>
            <p>新观念、新作风、新文化、新业绩。</p>
          </div>
          <div class="culture-grid" v-if="!culture.content">
            <article class="culture-slogan-card">
              <span>核心理念</span>
              <p>以人为本，铸造卓越团队，服务企业未来</p>
            </article>
            <article class="culture-card" v-for="item in cultureCards" :key="item.title">
              <div class="culture-card-top">
                <span class="culture-card-index">{{ item.index }}</span>
                <i :class="item.icon"></i>
              </div>
              <h4>{{ item.title }}</h4>
              <p>{{ item.desc }}</p>
            </article>
          </div>
          <div class="culture-rich-text" v-else v-html="culture.content"></div>
        </section>
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog
              :title="dialogTitle"
              :visible.sync="dialogTableVisible"
              width="720px"
              custom-class="honor-preview-dialog"
              append-to-body
            >
              <img v-lazy="dialogUrl" alt @click="dialogTableVisible = false" />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                v-lazy="imgserver+honor.img"
                @click="openHonorDialog(honor)"
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="imgserver + team.img"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner" v-if="partnerImg.length>0">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img v-lazy="imgserver+partner.img" alt />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      about:'',
      culture:'',
      cultureCards: [
        {
          index: "01",
          icon: "el-icon-refresh",
          title: "新观念",
          desc: "以开放视野拥抱产业变化，用创新思维推动技术持续升级。"
        },
        {
          index: "02",
          icon: "el-icon-s-operation",
          title: "新作风",
          desc: "保持专业、务实、高效的服务态度，把可靠交付落到每个项目细节。"
        },
        {
          index: "03",
          icon: "el-icon-trophy",
          title: "新业绩",
          desc: "以人为本凝聚团队力量，持续为客户、伙伴与企业未来创造价值。"
        }
      ],
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .all([
          this.$http.get("Honor"),
          this.$http.get("Enterprise"),
          this.$http.get("Team"),
          this.$http.get("Course"),
          this.$http.get("DataDictionary")
        ])
        .then(
          this.$http.spread(
            (responseHonor, responseEnterprise, responseTeam, responseCourse, responseDataDic) => {
              const dictionary = responseDataDic.result || [];
              this.honorList = responseHonor.result || [];
              this.partnerImg = responseEnterprise.result || [];
              this.teamItem = responseTeam.result || [];
              this.about = dictionary.find(x => x.key === "公司简介") || {};
              this.culture = dictionary.find(x => x.key === "企业文化") || {};
              this.courseList = this.chunkCourses(responseCourse.result || []);
            }
          )
        )
        .catch(error => {
          window.console.log(error);
          this.honorList = [];
          this.partnerImg = [];
          this.teamItem = [];
          this.courseList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    chunkCourses(list) {
      const groups = [];
      for (let i = 0; i < list.length; i += 2) {
        groups.push(list.slice(i, i + 2));
      }
      return groups;
    },
    openHonorDialog(honor) {
      this.dialogTableVisible = true;
      this.dialogUrl = this.imgserver + honor.img;
      this.dialogTitle = honor.remark || honor.Remark || "";
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}

.go-in {
  min-height: 100%;
  height: auto;
  overflow: visible;
  background: #eef4f8;
}

.go-in .section-content {
  width: min(1180px, 92%);
  margin: -34px auto 56px;
  padding: 36px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 2;
}

.go-in .content-summary {
  padding: 0 0 42px;
  gap: 34px;
  align-items: center;
  border-bottom: 1px solid #e3edf5;
}

.go-in .summary-left .title,
.go-in .top h3,
.go-in .content-culture h3 {
  color: #142235;
  font-weight: 700;
}

.go-in .summary-left .title {
  font-size: 30px;
}

.go-in .summary-left .eTitle,
.go-in .top p,
.go-in .content-culture h3 + h3 {
  color: #156da8;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}

.go-in .summary-left .content,
.go-in .summary-left p,
.go-in .content-culture span,
.go-in .content-culture p {
  color: #465a70;
  line-height: 1.9;
}

.go-in .summary-right {
  width: 400px;
  height: auto;
  margin-top: 0;
  padding: 10px;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  box-sizing: border-box;
  background: #f7fbfe;
}

.go-in .summary-right img {
  width: 100%;
  height: 270px;
  margin-top: 0;
  border-radius: 6px;
  object-fit: cover;
}

.go-in .content-course,
.go-in .content-honor,
.go-in .content-team,
.go-in .content-partner {
  padding: 46px 0;
  border-bottom: 1px solid #e3edf5;
}

.go-in .content-culture {
  height: auto;
  min-height: 260px;
  margin: 12px -36px 0;
  padding: 46px 72px;
  background: linear-gradient(135deg, #f7fbfe, #e9f8ff);
}

.go-in .top .border {
  width: 54px;
  border-bottom: 3px solid #2cace2;
  border-radius: 999px;
}

.go-in .el-divider {
  background-color: #d9e7f1;
}

.go-in .el-divider .el-divider__text {
  border-color: #d9e7f1;
  color: #156da8;
}

.go-in .content-course .course-time {
  width: min(1000px, 100%);
}

.go-in .content-course .time-show-item .item-bottom-content {
  border-radius: 8px;
  background: #156da8;
  box-shadow: 0 14px 28px rgba(21, 109, 168, 0.16);
}

.go-in .content-honor .honor-show {
  width: min(1000px, 100%);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 18px;
}

.go-in .content-honor .honor-show li {
  width: auto;
  height: 280px;
  margin-left: 0;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  overflow: hidden;
  background: #f7fbfe;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
}

.go-in .content-team {
  padding-left: 0;
  padding-right: 0;
}

.go-in .content-team .swiper-img {
  border-radius: 8px;
}

.go-in .content-partner {
  border-bottom: 0;
}

.go-in .content-partner .partner-img {
  width: min(950px, 100%);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 16px;
}

.go-in .content-partner .partner-img li {
  width: auto;
  height: 100px;
  margin: 0;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.go-in .content-partner .partner-img li img {
  width: 78%;
  height: 78%;
  border: 0;
  object-fit: contain;
}

@media (max-width: 900px) {
  .go-in .section-content {
    padding: 24px;
  }

  .go-in .content-summary {
    flex-direction: column;
    padding-bottom: 32px;
  }

  .go-in .summary-left,
  .go-in .summary-right {
    width: 100%;
  }

  .go-in .content-culture {
    margin-left: -24px;
    margin-right: -24px;
    padding: 36px 28px;
  }
}

@media (max-width: 680px) {
  .go-in .section-content {
    width: 94%;
    padding: 18px;
  }

  .go-in .content-culture {
    margin-left: -18px;
    margin-right: -18px;
    padding: 30px 20px;
  }
}

.go-in {
  background: #eef4f8;
}

.go-in .section-content {
  width: min(1240px, 92%);
  margin: -34px auto 56px;
  padding: 34px 42px 42px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 5;
}

.go-in .content-summary {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 42px;
  padding: 0 0 42px;
  align-items: center;
  border-bottom: 1px solid #e3edf5;
}

.go-in .summary-left {
  width: auto;
  min-width: 0;
}

.go-in .summary-left .title,
.go-in .top h3,
.go-in .content-culture h3:first-child {
  color: #142235;
  font-weight: 800;
  letter-spacing: 0;
}

.go-in .summary-left .title {
  font-size: 32px;
  line-height: 1.25;
}

.go-in .summary-left .eTitle,
.go-in .top p,
.go-in .content-culture h3 + h3 {
  margin-top: 6px;
  padding: 0;
  color: #156da8;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.go-in .summary-left .content,
.go-in .summary-left p,
.go-in .content-culture p,
.go-in .content-culture span {
  color: #465a70;
  font-size: 15px;
  line-height: 1.9;
}

.go-in .summary-left p[v-html] {
  text-indent: 0;
}

.go-in .summary-right {
  width: auto;
  height: auto;
  margin: 0;
  padding: 10px;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  background: #f7fbfe;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
}

.go-in .summary-right img {
  width: 100%;
  height: 300px;
  margin: 0;
  border-radius: 6px;
  object-fit: cover;
}

.go-in .el-divider-active {
  margin: 0;
  background: #d9e7f1;
}

.go-in .el-divider .el-divider__text {
  border-color: #d9e7f1;
  color: #156da8;
}

.go-in .content-course,
.go-in .content-honor,
.go-in .content-team,
.go-in .content-partner {
  padding: 46px 0;
  border-bottom: 1px solid #e3edf5;
}

.go-in .top {
  margin-bottom: 26px;
  text-align: center;
}

.go-in .top h3 {
  padding: 0;
  font-size: 28px;
  line-height: 1.3;
}

.go-in .top p {
  padding: 0;
}

.go-in .top .border {
  width: 54px;
  margin: 14px auto 0;
  border-bottom: 3px solid #2cace2;
  border-radius: 999px;
}

.go-in .content-course .course-time {
  width: min(980px, 100%);
  height: 360px;
  margin: 0 auto;
}

.go-in .content-course .time-show {
  width: min(760px, 100%);
  gap: 22px;
}

.go-in .content-course .time-show-item {
  min-width: 0;
}

.go-in .content-course .time-show-item .item-bottom-content {
  margin: 18px 0;
  border-radius: 8px;
  background: linear-gradient(180deg, #156da8, #0f5a8c);
  box-shadow: 0 14px 28px rgba(21, 109, 168, 0.16);
}

.go-in .content-course .time-show-item .item-bottom-content p {
  padding: 10px 14px;
  color: #fff;
  line-height: 1.6;
}

.go-in .content-course .time-show-item .item-bottom-content p:last-child {
  color: rgba(255, 255, 255, 0.76);
  font-weight: 700;
}

.go-in .content-culture {
  height: auto;
  min-height: 0;
  margin: 0 -42px;
  padding: 48px 72px;
  background: linear-gradient(135deg, #f7fbfe, #e9f8ff);
}

.go-in .content-culture h3 {
  font-size: 28px;
}

.go-in .content-culture h3 + h3 {
  margin-bottom: 18px;
}

.go-in .content-culture div {
  max-width: 860px;
}

.go-in .content-culture p {
  margin-bottom: 10px;
  color: #142235;
  font-size: 20px;
  font-weight: 700;
}

.go-in .content-culture span {
  display: block;
}

.go-in .content-honor .honor-show {
  width: min(1040px, 100%);
  margin: 0 auto 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 18px;
}

.go-in .content-honor .honor-show li {
  width: auto;
  height: 270px;
  margin: 0;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  overflow: hidden;
  list-style: none;
  background: #f7fbfe;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
}

.go-in .content-honor .honor-show img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
  transition: transform 0.25s ease;
}

.go-in .content-honor .honor-show li:hover img {
  transform: scale(1.03);
}

.go-in .content-honor > p {
  color: #607286;
  font-size: 13px;
  text-align: center;
}

.go-in .content-team {
  padding-left: 0;
  padding-right: 0;
}

.go-in .content-team .el-carousel {
  margin-top: 8px;
}

.go-in .content-team .swiper-img {
  height: 380px;
  border-radius: 8px;
  background-size: cover;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.08);
}

.go-in .content-partner {
  border-bottom: 0;
  padding-bottom: 4px;
}

.go-in .content-partner .partner-img {
  width: min(980px, 100%);
  margin: 24px auto 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(112px, 1fr));
  gap: 16px;
}

.go-in .content-partner .partner-img li {
  width: auto;
  height: 104px;
  margin: 0;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  background: #fff;
}

.go-in .content-partner .partner-img img {
  width: 78%;
  height: 78%;
  border: 0;
  object-fit: contain;
}

.go-in .honor-big-img {
  padding: 0;
}

.go-in .honor-big-img img {
  max-width: 100%;
  max-height: 72vh;
  display: block;
  margin: 0 auto;
  cursor: zoom-out;
  object-fit: contain;
}

:deep(.honor-preview-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.honor-preview-dialog .el-dialog__body) {
  padding: 18px;
  text-align: center;
  background: #f7fbfe;
}

:deep(.honor-preview-dialog .el-dialog__body img) {
  max-width: 100%;
  max-height: 72vh;
  cursor: zoom-out;
  object-fit: contain;
}

@media (max-width: 980px) {
  .go-in .section-content {
    padding: 28px;
  }

  .go-in .content-summary {
    grid-template-columns: 1fr;
    gap: 26px;
  }

  .go-in .content-culture {
    margin-left: -28px;
    margin-right: -28px;
    padding: 40px 32px;
  }
}

@media (max-width: 680px) {
  .go-in .section-content {
    width: 94%;
    padding: 18px;
  }

  .go-in .summary-left .title,
  .go-in .top h3,
  .go-in .content-culture h3:first-child {
    font-size: 24px;
  }

  .go-in .summary-right img,
  .go-in .content-team .swiper-img {
    height: 230px;
  }

  .go-in .content-course .course-time {
    height: auto;
  }

  .go-in .content-course .time-show {
    height: auto;
    flex-direction: column;
  }

  .go-in .content-course .time-show-item {
    width: 100%;
    height: auto;
  }

  .go-in .content-course .time-show-item .item-top {
    display: none;
  }

  .go-in .content-course .time-show-item .item-bottom {
    height: auto;
    order: 0;
  }

  .go-in .content-culture {
    margin-left: -18px;
    margin-right: -18px;
    padding: 32px 22px;
  }
}

.go-in .section .section-content .content-summary {
  padding: 34px 0 36px;
  justify-content: initial;
}

.go-in .section .section-content .content-culture {
  padding-top: 42px;
  padding-bottom: 42px;
}

.go-in .section .section-content .summary-right {
  margin-top: 0;
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-summary {
    padding: 22px 0 28px;
  }

  .go-in .section .section-content .content-culture {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}

.go-in .section .section-content .content-culture {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  column-gap: 46px;
  align-items: start;
}

.go-in .section .section-content .content-culture h3 {
  grid-column: 1;
}

.go-in .section .section-content .content-culture h3 + h3 {
  margin-bottom: 0;
}

.go-in .section .section-content .content-culture > div {
  grid-column: 2;
  grid-row: 1 / span 2;
  max-width: none;
  padding: 22px 26px;
  border: 1px solid #dbeaf4;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.05);
}

.go-in .section .section-content .content-culture > div p {
  margin-bottom: 12px;
}

.go-in .section .section-content .content-honor .honor-show {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.go-in .section .section-content .content-honor .honor-show li {
  height: 250px;
}

@media (max-width: 1080px) {
  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 820px) {
  .go-in .section .section-content .content-culture {
    grid-template-columns: 1fr;
    row-gap: 18px;
  }

  .go-in .section .section-content .content-culture > div {
    grid-column: 1;
    grid-row: auto;
  }

  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: 1fr;
  }
}

.go-in .section .section-content .content-culture {
  display: block;
  min-height: 0;
  padding: 38px 72px 44px;
  text-align: center;
}

.go-in .section .section-content .content-culture h3 {
  display: block;
}

.go-in .section .section-content .content-culture h3:first-child {
  font-size: 28px;
  line-height: 1.3;
}

.go-in .section .section-content .content-culture h3 + h3 {
  margin: 6px 0 22px;
  color: #156da8;
}

.go-in .section .section-content .content-culture > div {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 34px;
  text-align: left;
}

.go-in .section .section-content .content-culture > div p {
  margin-bottom: 14px;
  text-align: center;
}

.go-in .section .section-content .content-culture > div span {
  text-align: center;
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-culture {
    padding: 30px 20px 34px;
  }

  .go-in .section .section-content .content-culture > div {
    padding: 20px 18px;
  }
}

.go-in .section .section-content .content-honor .honor-show {
  width: min(1080px, 100%);
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.go-in .section .section-content .content-honor .honor-show li {
  height: auto;
  aspect-ratio: 3 / 4;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fcff;
}

.go-in .section .section-content .content-honor .honor-show img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.go-in .section .section-content .content-honor .honor-show li:hover img {
  transform: scale(1.01);
}

@media (max-width: 900px) {
  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .go-in .section .section-content .content-honor .honor-show {
    grid-template-columns: 1fr;
  }
}

.go-in .section .section-content .content-culture {
  margin: 0 -42px;
  padding: 42px 72px 48px;
  background: linear-gradient(180deg, #f7fbfe, #eaf7fd);
  text-align: center;
}

.go-in .section .section-content .content-culture h3:first-child {
  font-size: 28px;
  line-height: 1.3;
}

.go-in .section .section-content .content-culture h3 + h3 {
  margin: 6px 0 24px;
  color: #156da8;
}

.go-in .section .section-content .content-culture > div {
  max-width: 980px;
  margin: 0 auto;
  padding: 0;
  border: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  background: transparent;
  box-shadow: none;
}

.go-in .section .section-content .content-culture > div p,
.go-in .section .section-content .content-culture > div span {
  min-height: 104px;
  margin: 0;
  padding: 22px 20px;
  border: 1px solid #d9e9f4;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.82);
  color: #24364d;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.75;
  text-align: center;
  box-shadow: 0 12px 28px rgba(20, 34, 53, 0.05);
}

.go-in .section .section-content .content-culture > div p {
  color: #075b94;
  font-size: 18px;
  font-weight: 800;
}

@media (max-width: 980px) {
  .go-in .section .section-content .content-culture {
    margin-left: -28px;
    margin-right: -28px;
    padding: 38px 32px 42px;
  }

  .go-in .section .section-content .content-culture > div {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-culture {
    margin-left: -18px;
    margin-right: -18px;
    padding: 32px 20px 36px;
  }

  .go-in .section .section-content .content-culture > div p,
  .go-in .section .section-content .content-culture > div span {
    min-height: auto;
    padding: 18px;
  }
}

.go-in .section .section-content .content-culture {
  margin: 0 -42px;
  padding: 56px 72px;
  display: grid;
  grid-template-columns: minmax(220px, 0.34fr) minmax(0, 1fr);
  gap: 34px;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  // background:
  //   linear-gradient(110deg, rgba(8, 35, 60, 0.94), rgba(11, 82, 128, 0.86)),
  //   url("../assets/img/jianjietopmin.jpg") center / cover no-repeat;
  text-align: left;
}

.go-in .section .section-content .content-culture::before {
  content: "";
  position: absolute;
  inset: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  pointer-events: none;
}

.go-in .section .section-content .content-culture > .culture-head,
.go-in .section .section-content .content-culture > .culture-grid,
.go-in .section .section-content .content-culture > .culture-rich-text {
  grid-column: auto;
  grid-row: auto;
  max-width: none;
  margin: 0;
  padding: 0;
  border: 0;
  display: block;
  position: relative;
  z-index: 1;
  background: transparent;
  box-shadow: none;
}

.go-in .section .section-content .content-culture > .culture-head {
  padding: 30px 0 30px 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.go-in .section .section-content .content-culture .culture-kicker {
  display: inline-flex;
  width: fit-content;
  min-height: auto;
  margin: 0 0 12px;
  padding: 6px 12px;
  border: 1px solid rgba(134, 214, 255, 0.36);
  border-radius: 999px;
  // background: rgba(255, 255, 255, 0.08);
  color: black;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture .culture-head h3 {
  margin: 0;
  padding: 0;
  display: block;
  background: transparent;
  color: black;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0;
}

.go-in .section .section-content .content-culture .culture-head p {
  max-width: 320px;
  min-height: auto;
  margin: 16px 0 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  display: block;
  background: transparent;
  color: black;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.9;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture > .culture-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.go-in .section .section-content .content-culture .culture-card {
  min-height: 238px;
  padding: 28px 24px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 38px rgba(5, 18, 32, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.go-in .section .section-content .content-culture .culture-card:hover {
  transform: translateY(-4px);
  border-color: rgba(228, 61, 48, 0.28);
  box-shadow: 0 24px 48px rgba(5, 18, 32, 0.24);
}

.go-in .section .section-content .content-culture .culture-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.go-in .section .section-content .content-culture .culture-card-index {
  min-height: auto;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  display: block;
  background: transparent;
  color: #d63a30;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.3;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture .culture-card-top i {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  background: #eef7fc;
  color: #156da8;
  font-size: 20px;
}

.go-in .section .section-content .content-culture .culture-card h4 {
  margin: 18px 0 14px;
  color: #142235;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.35;
}

.go-in .section .section-content .content-culture .culture-card p {
  min-height: auto;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  display: block;
  background: transparent;
  color: #4d5f72;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.85;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture > .culture-rich-text {
  padding: 30px 32px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  color: #465a70;
}

.go-in .section .section-content .content-culture .culture-rich-text p,
.go-in .section .section-content .content-culture .culture-rich-text span {
  min-height: auto;
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  display: block;
  background: transparent;
  color: #465a70;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.9;
  text-align: left;
  box-shadow: none;
}

@media (max-width: 980px) {
  .go-in .section .section-content .content-culture {
    margin-left: -28px;
    margin-right: -28px;
    padding: 46px 32px;
    grid-template-columns: 1fr;
    gap: 26px;
  }

  .go-in .section .section-content .content-culture > .culture-head {
    padding: 0;
  }

  .go-in .section .section-content .content-culture .culture-head p {
    max-width: 620px;
  }
}

@media (max-width: 760px) {
  .go-in .section .section-content .content-culture > .culture-grid {
    grid-template-columns: 1fr;
  }

  .go-in .section .section-content .content-culture .culture-card {
    min-height: auto;
  }
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-culture {
    margin-left: -18px;
    margin-right: -18px;
    padding: 36px 20px;
  }

  .go-in .section .section-content .content-culture::before {
    inset: 12px;
  }

  .go-in .section .section-content .content-culture .culture-head h3 {
    font-size: 26px;
  }

  .go-in .section .section-content .content-culture .culture-card,
  .go-in .section .section-content .content-culture > .culture-rich-text {
    padding: 22px 20px;
  }
}

.go-in .section .section-content .content-culture .culture-slogan-card {
  grid-column: 1 / -1;
  min-height: 118px;
  padding: 26px 30px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 38px rgba(5, 18, 32, 0.16);
}

.go-in .section .section-content .content-culture .culture-slogan-card span {
  min-height: auto;
  margin: 0;
  padding: 0;
  border: 0;
  display: block;
  background: transparent;
  color: #d63a30;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.4;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture .culture-slogan-card p {
  min-height: auto;
  margin: 8px 0 0;
  padding: 0;
  border: 0;
  display: block;
  background: transparent;
  color: #142235;
  font-size: 25px;
  font-weight: 800;
  line-height: 1.45;
  text-align: left;
  box-shadow: none;
}

.go-in .section .section-content .content-culture .culture-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.go-in .section .section-content .content-culture .culture-card i {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eaf7fd;
  color: #0f5a8c;
  font-size: 22px;
}

@media (max-width: 680px) {
  .go-in .section .section-content .content-culture .culture-slogan-card {
    min-height: auto;
    padding: 22px 20px;
  }

  .go-in .section .section-content .content-culture .culture-slogan-card p {
    font-size: 21px;
  }
}
</style>
